export const MaskDefault = {
    phone : [
        {mask: '(00) 0000-0000'},
        {mask: '(00) 00000-0000'}
    ],
    cpf: "000.000.000-00",
    cnpj: "**.***.***/****-00",
    cpfAndCnpj: [
        {mask: "000.000.000-00"},
        {mask: "**.***.***/****-00"}
    ],
    cep: "00000-000",
    renavam: "00000000000",
    plate: [
        { mask: 'aaa-0000' },
        { mask: 'aaa 0000' },

        { mask: 'aaa-0a00' },
        { mask: 'aaa 0a00' },

        { mask: '0000aaa' },

        { mask: 'aa 000 aa' },

        { mask: 'aaaa 000' },

        { mask: '000 aaaa' }
    ],
    plateNoRestrict: [
        {mask: /^(?!.*[ -]{2})[a-z0-9 -]{0,11}$/i}
    ],
    plateWildcard: [
        {mask: /^(?!.*[ -]{2})[a-z0-9*?+ -]{0,11}$/i}
    ],
    money: [
        { mask: "0,00" },
        { mask: "00,00" },
        { mask: "000,00" },
        { mask: "0.000,00" },
        { mask: "00.000,00" },
        { mask: "000.000,00" },
        { mask: "0.000.000,00" },
    ],
    fuelQuantity: Number
};

export const parseStoredMoneyValue = (value) => {
    const stringValue = String(value ?? "").trim();

    if (!stringValue) return null;

    let numericValue;

    if (stringValue.includes(",")) {
        numericValue = Number(stringValue.replace(/\./g, "").replace(",", "."));
    } else if (stringValue.includes(".")) {
        numericValue = Number(stringValue);
    } else {
        numericValue = Number(stringValue) / 100;
    }

    return Number.isFinite(numericValue) ? numericValue : null;
};

export const formatStoredMoneyValue = (value, options = {}) => {
    const numericValue = parseStoredMoneyValue(value);

    if (numericValue === null) return "";

    return numericValue.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        ...options
    });
};

export const parseStoredFuelQuantity = (value) => {
    const stringValue = String(value ?? "").trim();

    if (!stringValue) return null;

    const numericValue = stringValue.includes(",")
        ? Number(stringValue.replace(/\./g, "").replace(",", "."))
        : Number(stringValue);

    return Number.isFinite(numericValue) ? numericValue : null;
};

export const formatStoredFuelQuantity = (value) => {
    const numericValue = parseStoredFuelQuantity(value);

    if (numericValue === null) return "";

    return numericValue.toLocaleString("pt-BR", {
        maximumFractionDigits: 3
    });
};
